import './layout.scss'
import CommonHeader from "./headers"
import SidebarComponent from "./sideBar"
import { useSelector } from 'react-redux'
import PopUpComponent from './popup'
import EntrepreneurHeader from './headers/entrepreneurHeader'

const Layout = ({ children, hasSideBar, isuserRole }) => {
    const isToggle = useSelector(state => state.componentReducer.isToggle)
    const isEntrepreneur = isuserRole?.includes('entrepreneur')
    const entrepreneurHeaderSpacing = isEntrepreneur ? 'pt-[128px] lg:pt-[75px]' : 'pt-20'
    const mainHeight = isEntrepreneur ? 'h-[calc(100vh-128px)] lg:h-[calc(100vh-75px)]' : 'h-[calc(100vh-5rem)]'

    return (
        <div className="min-h-screen flex flex-col dark:bg-gray-900 page-layout">
            <header className={`talwind-header w-full fixed top-0 z-[60] bg-white shadow dark:shadow-gray-400 transition-all duration-300 ${isEntrepreneur ? '' : 'h-20'}`}>
                {
                    isEntrepreneur ? <EntrepreneurHeader /> : <CommonHeader hasSideBar={hasSideBar} />
                }

            </header>
            <div className={`flex flex-1 ${entrepreneurHeaderSpacing} h-full`}>
                {
                    hasSideBar && <aside id="sidebar"
                        className={`talwind-dashboard bg-white h-[calc(100vh-5rem)] min-h-80 shadow-md shadow-gray-400 flex flex-col justify-between transition-all duration-300 dark:bg-[#212121] w-0 fixed md:relative ${isToggle ? "md:w-64" : "w-64 z-10 md:w-16"}`}
                    >
                        <SidebarComponent />
                    </aside>
                }

                <main className={`flex-1 ${!hasSideBar ? 'm-0' : isToggle ? 'ms-0 md:ms-4' : 'ms-0 md:ms-4'} min-h-80 shadow-gray-400 overflow-y-auto dark:bg-gray-800 dark:text-gray-100 ${mainHeight} scrollbar`}>
                    {children}
                </main>
            </div>
            <PopUpComponent />
        </div>

    );
}

export default Layout;
